import React, { useState, useEffect } from 'react';
import { X, Briefcase } from 'lucide-react';
import { Button } from './ui/button';

const VacationOverlay = ({ language }) => {
  // VACATION CONTROL - Set to true to show overlay, false to hide
  const SHOW_VACATION_OVERLAY = true; // Change this to true to enable
  
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only show if vacation mode is enabled
    if (SHOW_VACATION_OVERLAY) {
      setIsVisible(false);
    }
  }, []);

  const translations = {
    /*
    de: {
      title: 'Hinweis',
      message: 'Ich befinde mich derzeit noch im Gründungsprozess.',
      afterVacation: 'Ich kann voraussichtlich ab dem 01.04.2026 starten und bin dann gerne für Ihre Anliegen da.',
      contact: 'Sie können mir gerne vorab eine E-Mail schreiben – ich melde mich zeitnah bei Ihnen.',
      close: 'Verstanden'
    },
    en: {
      title: 'Notice',
      message: 'I am currently still in the process of setting up my company.',
      afterVacation: 'I expect to be able to start on April 1, 2026, and will be happy to assist you with your requests.',
      contact: 'Feel free to send me an email in advance — I will get back to you as soon as possible.',
      close: 'Understood'
    }
  };
  
  const translations = {
  */
    de: {
      title: 'Urlaubshinweis',
      message: 'Ich bin vom 24.08.2026 bis 06.09.2026 im Urlaub und in dieser Zeit nicht erreichbar.',
      afterVacation: 'Nach dem Urlaub bin ich gerne wieder für Ihre Anliegen da.',
      contact: 'Für dringende Anfragen können Sie mir gerne eine E-Mail schreiben – ich melde mich nach meiner Rückkehr bei Ihnen.',
      close: 'Verstanden'
    },
    en: {
      title: 'Vacation Notice',
      message: 'I am on vacation from August 24, 2026 to September 06, 2026 and will not be available during this time.',
      afterVacation: 'After my vacation, I will be happy to assist you with your concerns again.',
      contact: 'For urgent inquiries, you are welcome to send me an email – I will get back to you after my return.',
      close: 'Understood'
    }
  };
  
  const t = translations[language];

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-white dark:bg-gray-900 rounded-lg shadow-2xl max-w-md w-full p-6 relative animate-in fade-in duration-300">
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
          aria-label="Close"
        >
          <X className="h-6 w-6" />
        </button>

        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 rounded-full bg-[#E53D4A] flex items-center justify-center mb-4">
            <Briefcase className="h-8 w-8 text-white" />
          </div>

          <h2 className="text-2xl font-bold mb-3" style={{ color: '#E53D4A' }}>
            {t.title}
          </h2>

          <p className="text-gray-700 dark:text-gray-300 mb-3 leading-relaxed">
            {t.message}
          </p>

          <p className="text-gray-700 dark:text-gray-300 mb-3 leading-relaxed">
            {t.afterVacation}
          </p>

          <p className="text-sm text-gray-600 dark:text-gray-400 mb-6 leading-relaxed">
            {t.contact}
          </p>

          <Button
            onClick={() => setIsVisible(false)}
            className="w-full bg-[#E53D4A] hover:bg-[#d63340] text-white"
            size="lg"
          >
            {t.close}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VacationOverlay;
